import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=98524032&scoped=true&"
import script from "./HomeView.vue?vue&type=script&setup=true&lang=js&"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98524032",
  null
  
)

export default component.exports